import { render, staticRenderFns } from "./Demo.vue?vue&type=template&id=4f72ca50&scoped=true"
import script from "./Demo.vue?vue&type=script&lang=ts"
export * from "./Demo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f72ca50",
  null
  
)

export default component.exports